import anime, { AnimInstance } from 'animejs';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { InjectedPagesProps, withPages } from 'src/_context/Pages';
import {
  InjectedTransitionedContainerProps,
  transitionDirection,
  withTransitionedContainer
} from 'src/_context/TransitionedContainer';
import responsive from 'src/constants/responsive';
import { mobileSize } from 'src/constants/responsive';
import Page from './Page';

export type TransitionedRouteProps = {
  types: string[];
  direction: transitionDirection
};

const styles = {
  container: {
    position: 'relative',
    width: "100%",
    height: "100%"
  },
  viewContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    opacity: 0,
    [responsive.Mobile]: {
      opacity: 1
    }
  }
};

type Props =
  TransitionedRouteProps &
  InjectedPagesProps &
  InjectedTransitionedContainerProps &
  StyledComponentProps<keyof typeof styles>;

type View = {
  id: string;
  animation?: AnimInstance;
  active: boolean;
  page: IPageDto;
  container: React.RefObject<HTMLDivElement>;
}

type State = {
  views: View[];
};

class TransitionedRoute extends React.Component<Props, State> {

  state: Readonly<State> = {
    views: []
  };

  componentDidMount() {
    const { pagesCtx: { page, activeId }, types, direction, transitionedContainer } = this.props;

    if (page && types.indexOf(page.type) >= 0) {
      this.setState(
        ({ views }) => ({
          views: [
            ...views.map(v => ({ ...v, active: false })),
            {
              page,
              id: activeId,
              container: React.createRef<HTMLDivElement>(),
              active: true
            }
          ]
        }),
        () => this.state.views.map(v => this._fade(v, v.active))
      );
      transitionedContainer.move(direction);
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { pagesCtx: { activeId: prevActiveId } } = prevProps;
    const { pagesCtx: { page, activeId }, types, transitionedContainer, direction } = this.props;

    if (activeId !== prevActiveId) {
      if (page && types.indexOf(page.type) >= 0) {
        this.setState(
          ({ views }) => ({
            views: [
              ...views.map(v => ({ ...v, active: false })),
              {
                page,
                id: activeId,
                container: React.createRef<HTMLDivElement>(),
                active: true
              }
            ]
          }),
          () => this.state.views.map(v => this._fade(v, v.active))
        );
        transitionedContainer.move(direction);
        // request focus transitionContainer
      } else {
        // this.state.views.map(v => this._fade(v, false))
      }
    }
  }

  public render() {
    const { classes } = this.props;
    const { views } = this.state;

    return (
      <div className={classes!.container}>
        {views.map(v => (
          <div
            className={classes!.viewContainer}
            key={v.id}
            ref={v.container}
          >
            <Page {...v.page} />
          </div>
        ))}
      </div>
    );
  }

  private _fade(view: View, fadeIn: boolean) {
    if (!view.container.current) { return }
    const duration = 450;
    const isMobile = document.body.clientWidth <= (mobileSize - 1);

    anime({
      targets: view.container.current,
      opacity: fadeIn ? 1 : 0,
      easing: 'linear',
      duration: isMobile ? 0 : duration,
      delay: fadeIn && !isMobile ? duration : 0
    }).finished.then(() => {
      if (!fadeIn) {
        this.setState(({ views }) => ({
          views: views.filter(v => v !== view)
        }))
      }
    });
  }
}

export default withTransitionedContainer(withPages(withStyles(styles)(TransitionedRoute)));



// WEBPACK FOOTER //
// ./src/components/TransitionedRoute.tsx